// extracted by css-extract-rspack-plugin
export default {"diffEntry":"PullRequestDiffsList-module__diffEntry__djnVa"};